import React from "react";
import ReactDOM from "react-dom";
import colorLogo from "popdock-logos/popdock-color.svg";
import whiteLogo from "popdock-logos/popdock-white.svg";
import "./home.css";

function Home() {
    return (
        <div className="home">
            <div className="card">
                <picture className="logo">
                    <source srcSet={whiteLogo} media="(prefers-color-scheme: dark)" />
                    <img src={colorLogo} alt="Popdock" />
                </picture>
                <div className="status">
                    <span className="dot" />
                    Popdock MCP is running
                </div>
                <div className="url">{window.location.host}</div>
                <a className="help-link" href="https://www.popdock.ai" target="_blank" rel="noreferrer">Help</a>
            </div>
        </div>
    );
}

ReactDOM.render(<Home />, document.getElementById("content"));
